"use client";

import * as React from "react";

export default function PwaRegister() {
  React.useEffect(() => {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // SW registration should never block app usage.
    });
  }, []);

  return null;
}
